import * as React from "react";
import { apiRequest, ProcessT } from "@talentpair/api";
import { Box, Typography } from "@talentpair/quantic";
import { UserDataCard, DataRow } from "@talentpair/quantic/UserDataCard";
import { AssistantFullMessage, MessageControlProps, MessageT } from "../../types";
import { VoteButtons } from "../VoteButtons";

type PerryCandidatePreview = {
  role: string;
  companies: string[];
  location: string;
  education: string;
  skills: string[];
  industries: string[];
  salary: string;
};

type CandidateSearchResultsProps = AssistantFullMessage<{
  results: PerryCandidatePreview[];
}> &
  MessageControlProps;

export function CandidateSearchResults({
  sessionid,
  data,
  last,
  addMessages,
  setBgProcess,
}: CandidateSearchResultsProps): React.ReactElement | null {
  return "results" in data && Array.isArray(data.results) ? (
    <Box variant="column" layout="stretch-start" space={3}>
      {data.results.map((row, index) => (
        <UserDataCard key={String(index)} title={row.role}>
          <DataRow
            noborder
            label="Companies:"
            data={row.companies.length ? row.companies.join(", ") : "--"}
          />
          {row.education ? <DataRow label="Education:" data={row.education} /> : null}
          <DataRow label="Location:" data={row.location || "--"} />
          <DataRow label="Skills:" data={row.skills.length ? row.skills.join(", ") : "--"} />
          <DataRow
            label="Industries:"
            data={row.industries.length ? row.industries.join(", ") : "--"}
          />
          <DataRow label="Salary:" data={row.salary || "--"} />
        </UserDataCard>
      ))}
      <Box variant="column" layout="start-start" space={2}>
        <Typography variant="body2">
          {data.results.length === 1 ? "Does this candidate" : "Do these candidates"} look like they
          might be a good match for your role?
        </Typography>
        {last ? (
          <VoteButtons
            onUpvote={() =>
              apiRequest
                .post<{ messages: Array<{ content: MessageT }> }>("teleprompter/chat/upvote/", {
                  sessionid,
                })
                .then((res) => addMessages(...res.data.messages.slice(-2).map((m) => m.content)))
            }
            onDownvote={() =>
              apiRequest
                .post<ProcessT>("teleprompter/chat/downvote/", { sessionid })
                .then((res) => {
                  addMessages({
                    role: "hiring manager",
                    message: "Thumbed down the list of candidates.",
                  });
                  setBgProcess(res.data.uuid);
                })
            }
          />
        ) : null}
      </Box>
    </Box>
  ) : null;
}
